import React, { useEffect, useRef } from "react";
import { useInView } from "framer-motion";
import s from "./technology.module.css";
import { useDispatch, useSelector } from "react-redux";
import { selectScroll } from "../../redux/selectors";
import { goScroll } from "../../redux/slices/navigateSlice";

import { useNavigate } from "react-router-dom";

const Technologes = () => {
  const scroll = useSelector(selectScroll);
  const refTech = useRef(null);
 
  const dispatch = useDispatch();
  
 

  const navigator = useNavigate();
  const loraDiscr = [
    "LoRa (Long Range) — это технология беспроводной связи, предназначенная для передачи данных на большие расстояния с низким энергопотреблением. Она используется в сетях IoT (Интернета вещей) для подключения устройств, которые должны работать от батареи в течение длительного времени и передавать данные на расстояния в несколько километров.",
  ];

   const NbiotDiscr = [
    "Это технология, которая позволяет большому количеству устройств отправлять данные там, где нет стандартного покрытия мобильной сети. Он использует лицензированный частотный спектр, в котором нет помех другим устройствам, что гарантирует более надежную передачу данных. NB-IoT — это LPWAN (глобальные сети с низким энергопотреблением) — сеть, которая может покрывать большие территории, используя при этом меньшее количество энергии.",
  ];

   const MBusDiscr = [
    "Технология MBus (сокращение от Meter-Bus) — это стандартизированный протокол связи, разработанный для удаленного сбора данных с приборов учета, таких как счетчики воды, газа, тепла или электроэнергии. MBus широко используется в системах автоматизированного сбора показаний (АСКУЭ) и умных домах. ",
  ];
  const IoTDiscr = [
    "Технология IoT (Internet of Things) — это концепция, которая предполагает подключение различных устройств и объектов к интернету для обмена данными и автоматизации процессов. IoT позволяет устройствам взаимодействовать друг с другом, собирать информацию, анализировать её и выполнять задачи без прямого участия человека.",
  ];
 
  const RSDiscr = [
    "RS-485 (Recommended Standard 485) — это стандарт для передачи данных в последовательной сети, широко используемый в промышленных и коммерческих приложениях. Он определяет электрические характеристики двунаправленной передачи данных по витой паре проводов, что позволяет организовывать многоточечные сети с высокой устойчивостью к помехам.",
  ];
 

  useEffect(() => {
    if (scroll.tech) {
      refTech.current.scrollIntoView({ behavior: "smooth" });
      dispatch(goScroll({ ...scroll, tech: false }));
    }
  }, [scroll, dispatch]);

  const MiniCardsTech = ({className, item}) => {
    const ref = useRef(null);

    const isInView = useInView(ref, {
      margin: "0px 100px -55% 0px",
       });
    
    return (
      <div
        ref={ref}
        style={{
          opacity: isInView ? 1 : 0.2,
          transition: "all 0.5s ",
        }}
        onClick={()=>{navigator("/technology/"+item[1])}}
        className={className}
      >
        <div className={s.technologyBlockCenter}>
          <div className={s.blockNum}>
            <p className={s.technologyNumber} id={1}>
            {item[0]}
          </p>
          <h3 id={1}>{item[1]}</h3>
          </div>
          
          <div className={s.line}></div>
         
            <p className={s.technologyText2} id={3}></p>
            <p className={s.technologyText} id={1}>
            {item[2]}
          </p>
          
        </div>
      </div>
    );
  };

  return (
    <div>
      <div ref={refTech} className={s.technology}>
        <div className={s.container}>
          <div className={s.technologyBlock}>
            <div>
            <h2  style={{position:"sticky", top: "20px"}} className={s.technologyTitle}>Технологии</h2>
            </div>
            
            <div className={s.technologyCards}>
              <MiniCardsTech  className={s.cardLora}
                item={["01.", "Lora", loraDiscr]}
              ></MiniCardsTech>
              <MiniCardsTech className={s.technologyCard}
                item={["02.", "NB-Iot", NbiotDiscr]}
              ></MiniCardsTech>
              <MiniCardsTech className={s.technologyCard}
                item={[
                  "03.", "IoT", IoTDiscr
                ]}
              ></MiniCardsTech>
              <MiniCardsTech className={s.technologyCard}
                item={[
                  "04.",
                  "M-Bus",
                   MBusDiscr,
                ]}
              ></MiniCardsTech>
              <MiniCardsTech className={s.technologyCard}
                item={["05.", "RS-485", RSDiscr]}
              ></MiniCardsTech>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Technologes;
